import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Grid, Hide, Rectangle, Shadow, Space, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import VideoMessage from '../activity-stream/video';
import RosTopMpu from '../adverts/ros-top-mpu';
import UploadButton from './upload-button';
import BREAKPOINT from './breakpoint';

const NUMBER_OF_VIDEOS_BEFORE_ADVERT = 2;

const VideoList = ({ videos }) => {
  const videosBeforeAd = videos.slice(0, NUMBER_OF_VIDEOS_BEFORE_ADVERT);
  const videosAfterAd = videos.slice(NUMBER_OF_VIDEOS_BEFORE_ADVERT);

  return (
    <Shadow>
      <Rectangle fill="white" radius="rounded" style={{ height: '100%' }}>
        <Cushion vertical="medium" responsive={[{ minWidth: 'lap', props: { vertical: 'large' } }]}>
          <Cushion
            horizontal="medium"
            component="div"
            responsive={[{ minWidth: 'lap', props: { horizontal: 'medium' } }]}
          >
            <Hide maxWidth={BREAKPOINT}>
              <Space bottom="medium">
                <UploadButton fullWidth mediaType="videos">
                  <Trans i18nKey="media:upload_videos">Upload Videos</Trans>
                </UploadButton>
              </Space>
            </Hide>
            {videos.length > 0 && (
              <Space bottom="small">
                <Typography component="div" preset="tag--large" color="dustygrey">
                  <Trans i18nKey="media:related_videos_title">Recent Videos</Trans>
                </Typography>
              </Space>
            )}
          </Cushion>
          <Grid
            columns="minmax(0, 1fr)"
            responsive={[{ minWidth: 700, maxWidth: 1000, props: { columns: '1fr 1fr' } }]}
            rowGap="small"
            columnGap="large"
          >
            {videosBeforeAd.map((video) => (
              <VideoMessage key={video.id} message={video} stacked="never" messageType="video" />
            ))}
            <RosTopMpu />
            {videosAfterAd.map((video) => (
              <VideoMessage key={video.id} message={video} stacked="never" messageType="video" />
            ))}
          </Grid>
        </Cushion>
      </Rectangle>
    </Shadow>
  );
};

VideoList.defaultProps = {
  videos: [],
};

VideoList.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      author: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      }),
      description: PropTypes.string,
      duration: PropTypes.number,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      published: PropTypes.string,
      height: PropTypes.number,
      teamId: PropTypes.number,
      thumbnail: PropTypes.string,
      title: PropTypes.string.isRequired,
      url: PropTypes.string,
      views: PropTypes.number,
      width: PropTypes.number,
    }),
  ),
};

export default VideoList;
